module.exports = __webpack_public_path__ + "img/svg_en.6dfee2d4.svg";